import React from "react";
import { useHistory } from "react-router-dom";

import { Link, makeStyles } from "@fluentui/react-components";

import { LoginForm } from "../components/LoginForm";
import { useLoginForm } from "../utils/hooks/useLoginForm";

const useStyles = makeStyles({
  backLink: {
    alignSelf: "flex-start",
    marginBottom: "20px",
  },
  container: {
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "20px",
  },
  formContainer: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    padding: "40px",
    width: "100%",
  },
  title: {
    color: "#323130",
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "32px",
    textAlign: "center",
  },
});

export function CequenceLogin() {
  const history = useHistory();
  const styles = useStyles();
  const {
    formData,
    generalError,
    getFieldError,
    handleInputChange,
    handleSubmit,
    isLoading,
  } = useLoginForm();

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <Link className={styles.backLink} onClick={() => history.goBack()}>
          ← Back
        </Link>

        <h1 className={styles.title}>Sign in to Cequence</h1>

        <LoginForm
          formData={formData}
          generalError={generalError}
          getFieldError={getFieldError}
          isLoading={isLoading}
          onInputChange={handleInputChange}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
}
